<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/subGrupoProduto"> Cadastro/Produtos e Serviços/SubGrupos  </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao-produto />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col col="6">
            <v-text-field
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-text-field>
          </v-col>
          <v-col col="6">
            <v-select
              v-model="grupoSelected"
              :items="findGruposAtivos"
              label="Grupo *"
              item-text="descricao"
              item-value="id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'O Grupo é obrigatório']"
              required
            >
            </v-select>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/subGrupoProduto" color="error" class="mr-4">
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoProduto from "../../Tabs/TabCadastroProduto";
import { enviarSubGrupoProdutoAsync } from "../../../services/grupoProdutoService";
import { mapState, mapActions } from "vuex";

export default {
  name: "criarSubGrupo",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    grupoSelected: null,
  }),
  computed: {
    ...mapState("grupoProduto", ["gruposProduto"]),

    findGruposAtivos() {
      return this.gruposProduto.filter((g) => {
        return g.ativo === true;
      });
    }
  },
  methods: {
    ...mapActions("grupoProduto", ["addSubGrupoProduto"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarSubGrupoProdutoAsync(this.descricao, this.grupoSelected.id);
        if (!resposta || resposta.message || resposta.Message) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta && (resposta.message || resposta.Message) ? resposta.message || resposta.Message : "", "Descupe, falha na operação!", "error");
        } else {
          this.addSubGrupoProduto(this.mountObjSubGrupoProduto(resposta));
          this.overlay = false;
          this.$store.dispatch("ui/showSnackbar", {
            text: "Salvo com sucesso!",
            color: "success",
            timeout: 3000,
          });
          this.$router.push("/subGrupoProduto");
        }
      }
    },
    mountObjSubGrupoProduto(subGrupoSalvo) {
      return {
        ...subGrupoSalvo,
        grupoProduto: this.grupoSelected.descricao,
      };
    },
  },
  components: {
    TabNavegacaoProduto,
  },
};
</script>
